import { z } from 'zod';
import { ACCOMMODATION_TYPES, BOOKING_STATUSES } from '../constants/index';

const phoneRegex = /^\+?[0-9\s\-()]{7,20}$/;

export const BookingCreateSchema = z
  .object({
    name: z.string().trim().min(2, 'Укажите имя').max(120),
    phone: z
      .string()
      .trim()
      .regex(phoneRegex, 'Некорректный номер телефона')
      .max(30),
    email: z.string().trim().email('Некорректный email').max(200).optional().or(z.literal('')),
    accommodationType: z.enum(ACCOMMODATION_TYPES).optional(),
    checkin: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().or(z.literal('')),
    checkout: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional().or(z.literal('')),
    guests: z.number().int().min(1).max(30).optional(),
    comment: z.string().trim().max(2000).optional().or(z.literal('')),
    consentPdn: z.literal(true, {
      errorMap: () => ({ message: 'Необходимо согласие на обработку персональных данных' }),
    }),
    // honeypot — must be empty
    website: z.string().max(0).optional().or(z.literal('')),
  })
  .refine(
    (data) => {
      if (!data.checkin || !data.checkout) return true;
      return data.checkout > data.checkin;
    },
    { message: 'Дата выезда должна быть позже даты заезда', path: ['checkout'] },
  );

export type BookingCreateInput = z.infer<typeof BookingCreateSchema>;

export const BookingUpdateSchema = z.object({
  name: z.string().trim().min(2).max(120).optional(),
  phone: z.string().trim().regex(phoneRegex).max(30).optional(),
  email: z.string().trim().email().max(200).nullable().optional(),
  accommodationType: z.enum(ACCOMMODATION_TYPES).nullable().optional(),
  checkin: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  checkout: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).nullable().optional(),
  guests: z.number().int().min(1).max(30).nullable().optional(),
  comment: z.string().trim().max(2000).nullable().optional(),
  status: z.enum(BOOKING_STATUSES).optional(),
  priceTotal: z.number().int().min(0).nullable().optional(),
  adminNotes: z.string().trim().max(5000).nullable().optional(),
});

export type BookingUpdateInput = z.infer<typeof BookingUpdateSchema>;

export const BookingQuerySchema = z.object({
  status: z.enum(BOOKING_STATUSES).optional(),
  q: z.string().trim().max(200).optional(),
  from: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  to: z.string().regex(/^\d{4}-\d{2}-\d{2}$/).optional(),
  limit: z.coerce.number().int().min(1).max(200).default(50),
  offset: z.coerce.number().int().min(0).default(0),
});

export type BookingQuery = z.infer<typeof BookingQuerySchema>;
